/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Regex_LabelInputs */

const en_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regex`)
};

const fr_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regex`)
};

const de_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regex`)
};

const it_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espressione regolare`)
};

const ru_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регулярное выражение`)
};

const es_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expresión regular`)
};

const zh_cn2_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正则表达式`)
};

const ja_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現`)
};

const hi_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`regex`)
};

const pt_pt2_find_replace_regex_label = /** @type {(inputs: Find_Replace_Regex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular`)
};

/**
* | output |
* | --- |
* | "Regex" |
*
* @param {Find_Replace_Regex_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_regex_label = /** @type {((inputs?: Find_Replace_Regex_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Regex_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_regex_label(inputs)
	if (locale === "de") return de_find_replace_regex_label(inputs)
	if (locale === "it") return it_find_replace_regex_label(inputs)
	if (locale === "ru") return ru_find_replace_regex_label(inputs)
	if (locale === "es") return es_find_replace_regex_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_regex_label(inputs)
	if (locale === "ja") return ja_find_replace_regex_label(inputs)
	if (locale === "hi") return hi_find_replace_regex_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_regex_label(inputs)
	return en_find_replace_regex_label(inputs)
});